import React from 'react'

const Footer = (props) => (
    <footer id="footer">
        <div className="inner">
            <ul className="icons">
            <li><a href="https://twitter.com/interoplive" className="icon alt fa-twitter"><span className="label">Twitter</span></a></li>
            <li><a href="https://www.linkedin.com/company/interop-live/" className="icon alt fa-linkedin"><span className="label">LinkedIn</span></a></li>
            <li><a href="https://www.facebook.com/groups/2227513227528588/" className="icon alt fa-facebook"><span className="label">Facebook</span></a></li>
            </ul>
            <ul className="copyright">
                <li>&copy; Wales Institute for Digital Information</li><li>Design: <a href="https://html5up.net">HTML5 UP</a></li><li>Powered by <a href="https://www.gatsbyjs.org">Gatsby</a></li>
            </ul>
        </div>
    </footer>
)

export default Footer
